import { makeStateKey } from '@angular/core';

import { Location } from '@usheru-hff/shared/domain';

export const userLocationStateKey = makeStateKey<Location>('userLocation');
export const defaultChannelLocationStateKey = makeStateKey<Location>('defaultChannelLocation');
export const VIEWER_COUNTRY_KEY = makeStateKey<string>('cloudfront-viewer-country');
export const ushCountryVersionKey = makeStateKey<string>('ush_country_version');
